import React from 'react';
import './WelcomeScreen.css';

const WelcomeScreen = ({ onNext, data, onDataUpdate }) => {
  const handleGetStarted = () => {
    onDataUpdate({ agreedToStart: true });
    onNext();
  };

  return (
    <div className="welcome-screen">
      <div className="welcome-content">
        <h1>Title Here</h1>
        <button className="start-button" onClick={handleGetStarted}>
          Button
        </button>
      </div>
    </div>
  );
};

export default WelcomeScreen; 